import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FinancialAccount, ImpositionCondition } from '@api/models';
import { ROUTING_MENU, RouterMenuTypes } from '@core/config/routing-menu';
import { ClientType } from '@core/constants/client-type.constants';
import { HireDepositService } from '@core/services/hire-deposit/hire-deposit.service';
import { IProduct } from '@deposit/models/product-info.model';
import { ImpositionService } from '@deposit/services/imposition.service';
@Component({
    selector: 'app-select-deposit',
    templateUrl: './select-deposit.component.html',
    styles: [],
    standalone: false
})
export class SelectDepositComponent implements OnInit {
  @Input() deposits: FinancialAccount[];
  @Input() clientType: ClientType;

  buttonsToShow: { [key: string]: boolean } = {};
  allButtonsFalse: boolean;
  impositionConditions: ImpositionCondition[];
  selectedImpositionCondition: ImpositionCondition;

  constructor(
    @Inject(ROUTING_MENU) private readonly routingMenu: RouterMenuTypes,
    private router: Router,
    private hireDepositService: HireDepositService,
    private impositionService: ImpositionService,
  ) {}

  ngOnInit(): void {
    this.buttonsToShow = this.getButtonsToShow();
  }

  getButtonsToShow(): { [key: string]: boolean } {
    const buttons: { [key: string]: boolean } = {};

    buttons['button12'] = !this.deposits.some(
      (item) =>
        (item.ProductCode === '03510001003' || item.ProductCode === '03510001004') &&
        item.SFStatus === null,
    );
    buttons['button24'] = !this.deposits.some(
      (item) =>
        (item.ProductCode === '03510001001' || item.ProductCode === '03510001002') &&
        item.SFStatus === null,
    );
    buttons['button36'] = !this.deposits.some(
      (item) =>
        (item.ProductCode === '03510001005' || item.ProductCode === '03510001006') &&
        item.SFStatus === null,
    );

    this.allButtonsFalse = Object.values(buttons).every((value) => value === false);

    return buttons;
  }

  get depositHire() {
    return `/${this.routingMenu.PRIVATE_AREA}/${this.routingMenu.DEPOSIT}/hire`;
  }

  navigateToDepositHire(duration) {
    let productCode: string;

    if (duration === 12) {
      productCode = this.clientType === '01' ? '03510001003' : '03510001004';
    } else if (duration === 24) {
      productCode = this.clientType === '01' ? '03510001001' : '03510001002';
    } else if (duration === 36) {
      productCode = this.clientType === '01' ? '03510001005' : '03510001006';
    } else {
      console.error('clientType or productCode invalid!');
      return;
    }

    this.hireDepositService.setProductCode(productCode);

    this.impositionService.impositionConditions$.subscribe((data) => {
      this.impositionConditions = data;
      const filteredProduct = this.impositionConditions.filter(
        (productCondition) => productCondition.productCode === productCode,
      );
      this.selectedImpositionCondition = filteredProduct[0];

      const productInfo: IProduct = {
        impositionConditions: this.selectedImpositionCondition,
      };

      // Limpieza del productInfo anterior del localStorage si existe
      localStorage.removeItem('productInfo');

      // Se guarda productInfo en el localStorage
      localStorage.setItem('productInfo', JSON.stringify(productInfo));

      this.router.navigate([`/${this.routingMenu.PRIVATE_AREA}/${this.routingMenu.DEPOSIT}/hire`]);
    });
  }
}
